import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

const MLCardBgImg = ({ alt, className, src }) => {
    const classes = classnames('ml-card-background-img', className);
    const imageStyle = { backgroundImage: `url(${src})` };

    return (
        <div
            className={classes}
            style={imageStyle}
            title={alt}
        />
    );
};

MLCardBgImg.propTypes = {
    alt: PropTypes.string,
    className: PropTypes.string,
    src: PropTypes.string.isRequired,
};

export default MLCardBgImg;
